module.exports = __webpack_public_path__ + "static/InterFaceThin-Italic-0a1e84b30665ef04c46dbb2e1c6aadbb.woff";